import { defineStore } from "pinia";
import _ from "lodash";
import * as expenseService from "@/shared/api/expenseService";
import * as storeHelper from "@/shared/storeHelper";
import Vue from "vue";
import {
    FetchState,
    HsabExpenseEvidenceShoeboxInitialState,
    ManagedExpensePagedResponse
} from "@/shared/types";

export const initialState: HsabExpenseEvidenceShoeboxInitialState = {
    currentPage: {
        fetchState: FetchState.Uninitialized,
        page: 1,
        pageSize: 5,
        totalRecords: 0,
        numberOfPages: null,
        records: [],
    },
};

export const useHsabExpenseEvidenceShoeboxStore = defineStore("hsabExpenseEvidenceShoebox", {
    state: (): HsabExpenseEvidenceShoeboxInitialState => (_.cloneDeep(initialState)),
    getters: {
        isCurrentPageLoaded: state => state.currentPage.fetchState === FetchState.Loaded,
        isCurrentPageLoading: state => state.currentPage.fetchState === FetchState.Loading,
        currentPageItems: state => state.currentPage.records,
        currentPageNumber: state => state.currentPage.page,
        totalItemCount: state => state.currentPage.totalRecords,
        totalPageCount: state => state.currentPage.numberOfPages !== null ? state.currentPage.numberOfPages : 0,
    },
    actions: {
        overwriteRecordsForPage (response: ManagedExpensePagedResponse) {
            for (let index = this.currentPage.pageSize - 1; index >= 0; index--) {
                if (index < response.records.length) {
                    Vue.set(this.currentPage.records, index, response.records[index]);
                } else {
                    Vue.delete(this.currentPage.records, index);
                }
            }
        },
        async loadPage (page: number) {
            if (this.currentPage.fetchState === FetchState.Loading) {
                return Promise.resolve();
            }

            this.currentPage.fetchState = FetchState.Loading;

            return expenseService.getHsabExpenseEvidenceShoeboxByPage(page, this.currentPage.pageSize)
                .then(response => {
                    this.currentPage.page = page;
                    this.currentPage.totalRecords = response.data.totalRecords;
                    this.currentPage.numberOfPages = response.data.numberOfPages;
                    this.overwriteRecordsForPage(response.data);
                    this.currentPage.fetchState = FetchState.Loaded;
                })
                .catch(err => {
                    this.currentPage.fetchState = FetchState.Failed;
                    storeHelper.handleError({ error: err, rethrow: true });
                });
        },
        async OpenAttachment (shoeboxId: number) {
            const newTab = window.open();
            return expenseService.getHsabExpenseEvidenceShoeboxSignedS3Url(shoeboxId)
                .then(response => {
                    newTab.location.href = response.data;
                    setTimeout(() => {
                        if (newTab.location && newTab.location.href === "about:blank") {
                            newTab.close();
                        }
                    }, 2000);
                })
                .catch(err => {
                    storeHelper.handleError({ error: err, rethrow: false });
                    newTab.close();
                });
        }
    }
});